import React from 'react';
import Modal from '@material-ui/core/Modal';

const DMModal = ({open, onClose, children}) => {  
  return (
    <div>      
      <Modal
        open={open}        
        onClose={onClose}
        disableEnforceFocus>
        {children}
      </Modal>
    </div>
  );
}

export default DMModal;
